import { RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import CompanyMultiSelect from '@/components/CompanyMultiSelect';

const PRESETS = [30, 90, 365];

const FilterBar = ({ startDate, endDate, activePreset, companies, selectedCompanyUids, onStartDateChange, onEndDateChange, onPreset, onCompaniesChange, onReset }) => {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Input type="date" value={startDate} onChange={(e) => onStartDateChange(e.target.value)} className="h-8 w-36 text-xs" />
      <span className="text-xs text-muted-foreground">to</span>
      <Input type="date" value={endDate} onChange={(e) => onEndDateChange(e.target.value)} className="h-8 w-36 text-xs" />

      <div className="flex gap-1">
        {PRESETS.map((days) => (
          <Button key={days} variant={activePreset === days ? 'default' : 'outline'} size="sm" className="h-8 px-3 text-xs font-medium" onClick={() => onPreset(days)}>
            {days}d
          </Button>
        ))}
      </div>

      <div className="h-6 w-px bg-border" />

      <CompanyMultiSelect companies={companies} selectedUids={selectedCompanyUids} onChange={onCompaniesChange} align="start" />

      <Button variant="ghost" size="sm" onClick={onReset} className="h-8 gap-1.5 text-xs text-muted-foreground">
        <RotateCcw className="h-3.5 w-3.5" />
        Reset
      </Button>
    </div>
  );
};

export default FilterBar;
